import React, { Fragment } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const MultiSelect = ({
  items,
  selectedItems,
  handleChange,
  itemType,
  userDetail,
}) => {
  const isCitySelected = (name) =>
    selectedItems.some((item) => item.name === name);

  const isSelected = (id) => selectedItems.some((item) => item.id === id);

  return (
    <Fragment>
      {items.map((item) =>
        item.name?.length > 12 ? (
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={
              <Tooltip id={`tooltip-up`} className="">
                {item.name}
              </Tooltip>
            }
          >
            <label key={item.id} className="checkbox-container">
              <p> {item.name} </p>
              <input
                type="checkbox"
                id={item.id}
                value={item.id}
                onChange={(e) => handleChange(e, itemType, item.id, item.name)}
                checked={
                  itemType == "servicesCities"
                    ? isCitySelected(item.name)
                    : isSelected(item.id)
                }
              />
              <span className="checkmark"></span>
            </label>
          </OverlayTrigger>
        ) : (
          <label key={item.id} className="checkbox-container">
            <p> {item.name} </p>
            <input
              type="checkbox"
              id={item.id}
              value={item.id}
              onChange={(e) => handleChange(e, itemType, item.id, item.name)}
              checked={
                itemType == "servicesCities"
                  ? isCitySelected(item.name)
                  : isSelected(item.id)
              }
            />
            <span className="checkmark"></span>
          </label>
        )
      )}
    </Fragment>
  );
};

export default MultiSelect;
